import { ListResponse, SingleResponse } from '../../types'

export const createFakeListResponse = <T>(data: T[]): ListResponse<T> => {
	return { data }
}

export const createFakeSingleResponse = <T>(data: T): SingleResponse<T> => {
	return { data }
}
